<template>
 <div id="shareholderInformation-view" class="minHeight">
   <section class="section-1">
      <i-title :titleOne="'股东信息'" :titleTwo="'看在眼里的股东，使用更放心'"></i-title>
      <div class="main-title-content">
        <i class="icon-left"></i>
        <i class="icon-right"></i>
        <p>普惠理财（www.puhuilicai.com） 隶属于硅谷厚朴（北京）金融信息服务有限公司，硅谷厚朴成立于2014年8月，实缴资本5000万元，注册于北京市石景山区，硅谷厚朴（北京）金融信息服务有限公司是厚朴集团旗下的综合互联网金融服务商。</p>
        <p>厚朴集团有限公司是由皖新传媒、国佳投资、五福投资、中润产业等多家大型国企、上市公司，于2013年共同发起设立的供应链金融科技综合服务提供商。2017年中融资本、中朴创投、凯跃集团等战略股东相继投资厚朴。</p>
      </div>
      <div class="imgbox">
        <img src="../../assets/images/shareholder-Information.png" preview alt="" class="structure">
        <span>注：厚朴金控商业保理有限公司现已更名为厚朴供应链科技集团有限公司</span>
      </div>
   </section>
   <autograph></autograph>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
import informationTitle from '@/components/informationTitle'
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  },
  components: {
    'autograph': autograph,
    'i-title': informationTitle
  }
}
</script>

<style lang="less">
#shareholderInformation-view{
  width:980px;
  float: left;
  overflow: hidden;
  background: #fff;
  margin-left: 20px;
  margin-bottom: 20px;
  position: relative;
  .section-1{
    margin-bottom: 100px;
    .main-title-content{
      position: relative;
      i {
        position: absolute;
        display: block;
        width: 28px;
        height: 25px;
        background: url(../../assets/images/autograph.png);
      }
      .icon-left{
        top:-40px;
        left:55px;
        background-position: -150px -30px;
      }
      .icon-right{
        background-position: -30px -110px;
        bottom:-10px;
        right: 70px;
      }
      p{
        width: 780px;
        margin: 0 auto;
        margin-bottom: 20px;
        line-height: 2;
        font-size: 14px;
        color: #323232;
      }
    }
    .imgbox{
      width: 780px;
      margin: 0 auto;
      margin-top: 80px;
      .structure{
        width: 780px;
        height: 496px;
        margin: 0 auto;
      }
      span{
        display: inline-block;
        margin-top: 50px;
        font-size: 14px;
        color: #323232;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/shareholderInformation.vue